import { useRef } from 'react';

/**
 * Держит актуальное значение в ref для колбэков с фиксированным замыканием
 * (debounce, подписки, эффекты со стабильными deps).
 */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}
